import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/business/orderCargo/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/business/orderCargo',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/business/orderCargo',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/business/orderCargo/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/business/orderCargo',
    method: 'get',
    params: {
      id
    }
  })
}
